import { IdXboxFormsResponse } from "../../server/crm/api/models/forms";
import {
  OneVetResponse,
  PartnerCenterEnrollmentStatus,
} from "../../server/crm/dataService/models/staticOptions";
import { FieldOption } from "../../server/edsApi/models/forms";
import { OnboardingRootState } from "../reducers/rootReducer";
import { getCurrentProgramData } from "./programsSelectors";

const getStudio = (state: OnboardingRootState) =>
  (getCurrentProgramData(state) as IdXboxFormsResponse)?.studio;

export const getPartnerCenterToken = (state: OnboardingRootState): string =>
  getStudio(state)?.partnerCenterToken;

export const getIsPartnerCenterTokenStored = (state: OnboardingRootState): boolean | undefined =>
  getStudio(state)?.isPartnerCenterTokenStored;

export const getSellerID = (state: OnboardingRootState): string => getStudio(state)?.sellerID;

export const getOneVetResponse = (state: OnboardingRootState): OneVetResponse | undefined =>
  getStudio(state)?.oneVetResponse;

export const getPartnerCenterEnrollmentStatus = (
  state: OnboardingRootState
): PartnerCenterEnrollmentStatus => getStudio(state)?.partnerCenterEnrollmentStatus;

export const getOrdersInfoArray = (state: OnboardingRootState): Array<FieldOption> | undefined =>
  getStudio(state)?.orders?.ordersInfoArray;
